// @ts-nocheck
import OrderUploadReducer from "@insite/client-framework/Store/Components/OrderUpload/OrderUploadReducer";
import MinicartDrawerReducer, {
    MinicartDrawerActions,
} from "@store/Framework/Store/Store/Components/MinicartDrawer/MinicartDrawerReducer";
import PartFinderReducer, {
    PartFinderActions,
} from "@store/Framework/Store/Store/Components/PartFinder/PartFinderReducer";
import ScratchAndDentFormReducer, {
    ScratchAndDentFormActions,
} from "@store/Framework/Store/Store/Components/ScratchAndDentForm/ScratchAndDentFormReducer";
import WarrantyFormReducer from "@store/Framework/Store/Store/Components/WarrantyForm/WarrantyFormReducer";
import { combineReducers } from "redux";

const componentsReducers = {
    minicartDrawer: MinicartDrawerReducer,
    scratchAndDentForm: ScratchAndDentFormReducer,
    storeOrderUpload: OrderUploadReducer,
    partFinder: PartFinderReducer,
    warrantyForm: WarrantyFormReducer,
};

export type StoreComponentsActions =
    | MinicartDrawerActions
    | PartFinderActions
    | ScratchAndDentFormActions
    | typeof OrderUploadReducer;
export default combineReducers(componentsReducers);
